import Vue from 'vue'
import Router from 'vue-router'
//首页
import BskContent from '@/components/Layout/bskContent'//主内容页
import ModuleTemplate from '@/components/Content/ModuleTemplate'//嵌套主容页
import ModuleList from '@/components/Content/ModuleList' // 查看全部课程列表
import DownLoad from '@/components/Layout/downLoad'  //下载页面
import About from '@/components/Layout/About'  //版权页
import Introduce from '@/components/Layout/Introduce'
// 支付
import Order from '@/components/Dialogs/OrderPage'
// 视频
import Video from '@/components/Video/Video'
// 登录和注册
import Login from '@/components/Log/Login'
import Register from '@/components/Log/Register'
import Forget from '@/components/Log/Forget'
// 个人中心
import Personal from '@/components/Personal/Personal'
import PersonalCourseList from '@/components/Personal/PersonalCourseList' //课程
import PersonalOrderList from '@/components/Personal/PersonalOrderList' //订单
import PersonalBalance from '@/components/Personal/PersonalBalance' //余额
import PersonalVoucher from '@/components/Personal/PersonalVoucher' //优惠券
import PersonalQuiz from "@/components/Personal/PersonalQuiz";
//模考
import DryMain from '@/components/DryRun/main'//模考报名
import Exam from '@/components/DryRun/Exam'//答题
import testResults from '@/components/DryRun/testResults.vue'//结果
import SubjectId from '@/components/DryRun/subjectId.vue'//解析

//照片处理
import pictureTool from '@/components/smallTool/pictureTool.vue'
//资讯
import Information from '@/components/Layout/infomation'
//问答
import QuizHome from "../components/Quiz/QuizHome";
import QuizDetail from "../components/Quiz/QuizDetail";
//课程分类页
import CoursePage from '@/components/Layout/coursePage'
//师资介绍
import TeachersInfo from '@/components/Layout/teachersInfo'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: BskContent,
    //alias: '',
    // 路由是有优先级的，先定义先匹配。
    children: [
      {
        path: '/page/:page_id',
        name: 'IndexModules',
        component: ModuleTemplate,
      },
      {
        path: '/page/4',
        name: 'Index',
        component: ModuleTemplate,
        alias: ''
      },
      {//查看全部，先放放
        path: '/list/:list_id',
        name: 'ModuleList',
        component: ModuleList
      }
    ],
  },
  // 支付
  {
    path: '/order',
    name: 'Order',
    component: Order,
  },
  //视频
  {
    path: '/video/course_id/:course_id',
    name: 'Video',
    component: Video
  },
  {
    path: '/video/course_id/:course_id/video_id/:video_id',
    name: 'VideoWithId',
    component: Video
  },
  //下载页
  {
    path: '/download',
    name: 'download',
    component: DownLoad
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: Register
  // },
  // {
  //   path: '/forget',
  //   name: 'forget',
  //   component: Forget
  // },
  //个人中心：
  {
    path: '/personal',
    component: Personal,
    children: [{
      path: '',
      name: 'PersonalCourseList',
      component: PersonalCourseList,
      alias: 'courselist',
    }, {
      path: 'order',
      name: 'PersonalOrderList',
      component: PersonalOrderList,
    }, {
      path: 'balance',
      name: 'PersonalBalance',
      component: PersonalBalance
    }, {
      path: 'voucher',
      name: 'PersonalVoucher',
      component: PersonalVoucher
    },{
      path: 'myquiz',
      name: 'PersonalQuiz',
      component: PersonalQuiz,
    }]
  },
  // 版权页：
  {
    path: '/about/:page',
    name: 'about',
    component: About
  },
  //模考
  {
    path: '/drymain',
    name: 'DryMain',
    component: DryMain
  },
  {
    path: '/exam/:paperId',
    name: 'Exam',
    component: Exam,
  },
  {
    path: '/subjectId/:subjectId',
    name: 'SubjectId',
    component: SubjectId
  },
  {
    path: '/testresults/:paperId',
    name: 'testresults',
    component: testResults,
  },
  {
    path: '/pictureTool',
    name: 'pictureTool',
    component: pictureTool,
  },
  {
    path: '/information',
    name: 'information',
    component: Information,
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: QuizHome,
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/quiz/quiz_id/:quiz_id',
    name: 'quizDetail',
    component: QuizDetail,
    meta: {
      keepAlive: true,
    }
  },
  {
    path:'/introduce',
    name:'introduce',
    component: Introduce,
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/coursePage',
    name: 'CoursePage',
    component: CoursePage,
  },
  {
    path: '/teachersInfo',
    name: 'TeachersInfo',
    component: TeachersInfo,
    meta: {
      keepAlive: true,
    }
  },
]

export default new Router({
  mode: 'history',
  routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js